import produce from 'immer'

import { transformNormalizedToTyped } from 'packages/utils/store'

import {
  CrossCoverage,
  CrossCoverageAttributeNames,
  CrossCoverageResponse,
  NormalizedCrossCoverageApiResponse,
  RawCrossCoverage,
} from './crossCoverage.types'

export const emptyNormalizedCrossCoverageData: CrossCoverageResponse =
  Object.freeze({
    crossCoverage: {},
    user: {},
  })

export const emptyCrossCoverageResponse: NormalizedCrossCoverageApiResponse =
  Object.freeze({
    normalized: emptyNormalizedCrossCoverageData,
    raw: { data: [] },
  })

export const hydrateRawCrossCoverage = (
  raw: RawCrossCoverage,
): CrossCoverage => {
  return produce(
    transformNormalizedToTyped<CrossCoverage>(raw, CrossCoverageAttributeNames),
    draft => {
      draft.userCoveringId = raw?.relationships?.userCovering?.data?.id || ''
    },
  )
}
